import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "./layout";
import { ActivityPage, AnalyticsPage, ContentPage, CreatePage, MilestonesPage, OverviewPage, PipelinePage, SchedulePage, SettingsPage } from "./pages";
import "./styles.css";

if (window.location.hostname === "tauri.localhost") {
  void navigator.serviceWorker?.getRegistrations().then(registrations => Promise.all(registrations.map(registration => registration.unregister())));
  if ("caches" in window) void caches.keys().then(keys => Promise.all(keys.map(key => caches.delete(key))));
}

const router = createBrowserRouter([{ path: "/", element: <Layout />, children: [
  { index: true, element: <OverviewPage /> }, { path: "pipeline", element: <PipelinePage /> },
  { path: "create", element: <CreatePage /> }, { path: "schedule", element: <SchedulePage /> },
  { path: "content", element: <ContentPage /> }, { path: "analytics", element: <AnalyticsPage /> },
  { path: "milestones", element: <MilestonesPage /> }, { path: "activity", element: <ActivityPage /> },
  { path: "settings", element: <SettingsPage /> }
]}]);

const client = new QueryClient({ defaultOptions: { queries: { staleTime: 15_000, retry: 1 } } });
createRoot(document.getElementById("root")!).render(<StrictMode><QueryClientProvider client={client}><RouterProvider router={router} /></QueryClientProvider></StrictMode>);
